import React from 'react';

interface TableColumn {
  key: string; // Unique key for each column
  label: string; // Label for the column header
  width?: string; // Optional width for the column
  align?: 'left' | 'center' | 'right'; // Optional alignment for the column content
  render?: (row: any, index?: number) => JSX.Element;
  disableSort: boolean;
}
export const getColumns = (): TableColumn[] => {
  return [
    {
      key: 'question',
      label: 'Question',
      width: '350px',
      align: 'left' as const,
      disableSort: true,
    },
    {
      key: 'relatedField',
      label: 'Related Field',
      width: '220px',
      align: 'left' as const,
      disableSort: true,
    },
    {
      key: 'level',
      label: 'Skill Level',
      width: '200px',
      align: 'left' as const,
      disableSort: true,
    },
    {
      key: 'jobTitle',
      label: 'Job Title',
      width: '200px',
      align: 'left' as const,
      disableSort: true,
    },
  ];
};
